export default __webpack_public_path__ + "static/media/bx-chevron-down-gray.71acec18.svg";